import {
  Box,
  Typography,
  CardContent,
  Card,
  Grid,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import DOMPurify from 'dompurify';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { ticketHistory } from '../../data/mockData';
import { formatToIST } from '../../utils/dateFormatter';

const TicketDetails = () => {
  const location = useLocation();
  const { ticket } = location.state || {};

  if (!ticket)
    return (
      <Card
        sx={{
          boxShadow: 2,
          borderRadius: 2,
          padding: 1,
          margin: 2,
          marginLeft: 4,
        }}
      >
        <CardContent>
          <Box sx={{ padding: 4 }}>
            <Typography>No Ticket selected</Typography>
          </Box>
        </CardContent>
      </Card>
    );

  const sanitizedDescription = DOMPurify.sanitize(ticket.description);

  return (
    <>
      <Card
        sx={{
          boxShadow: 2,
          borderRadius: 2,
          margin: 2,
          marginLeft: 4,
        }}
      >
        <CardContent>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingLeft: 4,
              paddingTop: 2,
              paddingBottom: 0,
            }}
          >
            <Typography variant="h5" gutterBottom>
              Ticket #{ticket.ticketNo} Details{' '}
            </Typography>
          </Box>
        </CardContent>
      </Card>
      <Card
        sx={{
          boxShadow: 2,
          borderRadius: 2,
          padding: 1,
          margin: 2,
          marginLeft: 4,
        }}
      >
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: 'bold', paddingLeft: 4 }}>
            Ticket Details
          </Typography>
          <Box sx={{ padding: 3, paddingLeft: 4 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Ticket No.</strong>: {ticket.ticketNo}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Creation Date</strong>:{' '}
                  {ticket.creationDate
                    ? formatToIST(ticket.creationDate)
                    : 'N/A'}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Email ID</strong>: {ticket.email}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Ticket Category</strong>: {ticket.category}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography>
                  <strong>Ticket Description</strong>:{' '}
                  <Typography
                    component="div"
                    mt={2}
                    sx={{
                      border: '1px solid ',
                      padding: 3,
                    }}
                    dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
                  />
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Final Status</strong>:{' '}
                  <Chip label={ticket.status} color="success" />
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <strong>Priority</strong>:{' '}
                  <Chip label={ticket.priority} color="error" />
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography>
                  <strong>Attached File</strong>:{' '}
                  <Link href="#" underline="hover">
                    {ticket.attachmentFile}
                  </Link>
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </CardContent>
      </Card>

      <Card
        sx={{
          boxShadow: 2,
          borderRadius: 2,
          padding: 1,
          margin: 2,
          marginLeft: 4,
        }}
      >
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: 'bold', paddingLeft: 4 }}>
            Ticket History
          </Typography>
          <Box sx={{ padding: 3, paddingLeft: 4 }}>
            <Grid container spacing={2}>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Ticket Updated Details</TableCell>
                      <TableCell>Attached File (if any)</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Updated By</TableCell>
                      <TableCell>Date</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {ticketHistory.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell>{row.details}</TableCell>
                        <TableCell>
                          {row.file === 'Click Here' ? (
                            <Link href="#" underline="hover">
                              {row.file}
                            </Link>
                          ) : (
                            row.file
                          )}
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={row.status}
                            color={
                              row.status === 'Resolved'
                                ? 'success'
                                : row.status === 'In Process'
                                  ? 'primary'
                                  : 'default'
                            }
                          />
                        </TableCell>
                        <TableCell>{row.updatedBy}</TableCell>
                        <TableCell>
                          {row.date ? formatToIST(row.date) : 'N/A'}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Box>
        </CardContent>
      </Card>
    </>
  );
};

export default TicketDetails;
